<div *ngIf="event.isWebRTC" [id]="'webRTCLayoutContainer' + event.id" class="webRTCLayoutContainer bg-light" #webRTCLayoutContainer style="height: calc(30vh); border: 1px solid black"></div>
<div class="preview-wrapper" [ngClass]="{ previewing: previewing }">
  <div *ngIf="!event.isWebRTC" #livePLayer [id]="'livePLayer' + event.id" class="azuremediaplayer amp-default-skin embed-responsive live-player live-player-fluid hide-fullscreen" style="z-index: 0; height: calc(30vh); border: 1px solid black"  autoplay></div>
</div>
<div *ngIf="!event.isWebRTC" class="bg-dark p-2 d-flex">
  <div class="mr-auto">
    <ul class="list-inline mb-0 text-white">
      <li class="list-inline-item mr-2" data-toggle="tooltip" data-placement="top" title="" data-original-title="Settings">
        <span *ngIf="videoHealthData.length > 0"> Stream Health: <i class="fas fa-circle txt-danger" [ngClass]="{ 'text-success': videoHealthData[videoHealthData.length - 1].healthy, 'text-danger': !videoHealthData[videoHealthData.length - 1].healthy }"></i></span>
      </li>
      <li class="list-inline-item mr-2" data-toggle="tooltip" data-placement="top" title="" data-original-title="Settings">
        <span *ngIf="videoHealthData.length > 0"
          >Video Bitrate: <strong>{{ videoHealthData[videoHealthData.length - 1].incomingBitrate | bytes }}/s</strong>
        </span>
      </li>

      <li class="list-inline-item mr-2" data-toggle="tooltip" data-placement="top" title="" data-original-title="Settings">
        <span>End Time: <strong>{{event.endTime | date:'shortTime'}}</strong></span>
      </li>
    </ul>
  </div>
</div>

<div *ngIf="event.isWebRTC" class="bg-dark p-2 d-flex">
  <div class="mr-auto">
    <ul class="list-inline mb-0">
      <li class="list-inline-item mr-2" data-toggle="tooltip" data-placement="top" title="" data-original-title="Settings">
        <button *ngIf="!publishing" type="button" (click)="activateCamera()" class="btn btn-xs btn-success transition-3d-hover"><i class="fas fa-video"></i> Join Video</button>
        <button *ngIf="publishing" type="button" (click)="unpublish()" class="btn btn-xs btn-danger transition-3d-hover"><i class="fas fa-video-slash"></i> Leave Video</button>
      </li>
      <li *ngIf="publishing && publishingVideo" class="list-inline-item mr-2" data-toggle="tooltip" data-placement="top" title="" data-original-title="Settings">
        <button type="button" (click)="toggleVideo()" class="btn btn-sm btn-icon btn-success transition-3d-hover">
          <span class="fas fa-video"></span>
        </button>
      </li>
      <li *ngIf="publishing && !publishingVideo" class="list-inline-item mr-2" data-toggle="tooltip" data-placement="top" title="" data-original-title="Settings">
        <button type="button" (click)="toggleVideo()" class="btn btn-sm btn-icon btn-primary transition-3d-hover">
          <span class="fas fa-video-slash"></span>
        </button>
      </li>
      <li *ngIf="publishing && publishingAudio" class="list-inline-item mr-2" data-toggle="tooltip" data-placement="top" title="" data-original-title="Settings">
        <button type="button" (click)="toggleAudio()" class="btn btn-sm btn-icon btn-success transition-3d-hover">
          <span class="fas fa-microphone"></span>
        </button>
      </li>
      <li *ngIf="publishing && !publishingAudio" class="list-inline-item mr-2" data-toggle="tooltip" data-placement="top" title="" data-original-title="Settings">
        <button type="button" (click)="toggleAudio()" class="btn btn-sm btn-icon btn-primary transition-3d-hover">
          <span class="fas fa-microphone-slash"></span>
        </button>
      </li>
    </ul>
  </div>
  <div class="ml-auto">
    <ul class="list-inline mb-0">
      <li class="list-inline-item device-settings-button" data-toggle="tooltip" data-placement="top" title="" data-original-title="Settings">
        <button (click)="showDeviceSettings()" type="button" class="btn btn-sm btn-icon btn-secondary transition-3d-hover">
          <span class="fas fa-cog btn-icon__inner"></span>
        </button>
      </li>
      <li *ngIf="!soundMuted" class="list-inline-item mr-2" data-toggle="tooltip" data-placement="top" title="" data-original-title="Settings">
        <button type="button" (click)="muteAudio()" class="btn btn-sm btn-icon btn-success transition-3d-hover">
          <span class="fas fa-volume"></span>
        </button>
      </li>
      <li *ngIf="soundMuted" class="list-inline-item mr-2" data-toggle="tooltip" data-placement="top" title="" data-original-title="Settings">
        <button type="button" (click)="unMuteAudio()" class="btn btn-sm btn-icon btn-primary transition-3d-hover">
          <span class="fas fa-volume-mute"></span>
        </button>
      </li>
    </ul>
  </div>
</div>
<div class="bg-dark p-2 d-flex">
  <div class="mr-auto">
    <ul class="list-inline mb-0">
      <li *ngIf="event.streamingStarted && timer$ | async as elapsed" class="list-inline-item mr-2" data-toggle="tooltip" data-placement="top" title="" data-original-title="Broadcast is running">
        <span *ngIf="elapsed.pre" class="text-warning">INTRO</span>
        <span *ngIf="!elapsed.pre" class="text-success">LIVE</span>
        <span class="ml-2" style="font-family: courier; color: white">{{ elapsed.hours | LeftPadFilter }}:{{ elapsed.minutes | LeftPadFilter }}:{{ elapsed.seconds | LeftPadFilter }}</span>
      </li>
    </ul>
  </div>
  <div class="ml-auto">
    <ul class="list-inline mb-0">
      <li class="list-inline-item mr-2" data-toggle="tooltip" data-placement="top" title="" data-original-title="Settings">
        <button type="button" (click)="showQuestions = !showQuestions; showPeople = false" class="btn btn-sm btn-icon btn-warning transition-3d-hover">
          <span class="fas fa-question"></span>
        </button>
      </li>
      <li class="list-inline-item mr-2" data-toggle="tooltip" data-placement="top" title="" data-original-title="Settings">
        <button type="button" (click)="showTools = !showTools; showPeople = false; (showQuestions)" class="btn btn-sm btn-icon btn-danger transition-3d-hover">
          <span class="fas fa-tools"></span>
        </button>
      </li>

      <li *ngIf="userCount > 0" class="list-inline-item mr-0">
        <a class="btn btn-sm btn-icon btn-light rounded-circle" type="button" (click)="showPeople = !showPeople; showQuestions = false">
          <span class="btn-icon__inner">{{ userCount }}</span>
        </a>
      </li>
    </ul>
  </div>
</div>
<div class="popover-window no-margin col p-0" [ngClass]="{ 'd-none': !showPeople }">
  <live-people [event]="event" [connection]="connection" (usersUpdated)="usersUpdated($event)" (closed)="showPeople = false; showQuestions = false; showTools = false"></live-people>
</div>
<div class="popover-window no-margin col p-0" [ngClass]="{ 'd-none': !showQuestions }">
  <live-questions [event]="event" (closed)="showPeople = false; showQuestions = false; showTools = false" [connection]="connection"></live-questions>
</div>
<div class="popover-window no-margin col p-0" [ngClass]="{ 'd-none': !showTools }">
  <bxl-live-superuser [event]="event" [connection]="connection" (closed)="showPeople = false; showQuestions = false; showTools = false"></bxl-live-superuser>
</div>
